import React, { useState, useEffect } from "react";
import { useTheme } from "next-themes";
import CreationTable from "./CreationTable";
import importBlocksAndAllocationsStore from "@/store/importBlocksAndAllocationsStore";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchRequestWrapper } from "@/lib/utilities";
import { logClientError } from "@/lib/errorLoggingACTIONS";

const CreationIndex = ({ cryptoID }: { cryptoID: string }) => {
  const { theme } = useTheme();

  const importData = importBlocksAndAllocationsStore(
    (state) => state.allBlocks,
  );

  const setIncomingBlockDataInStore = importBlocksAndAllocationsStore(
    (state) => state.setImportBlocks,
  );

  // This will be used to store the selected blocks

  const { getAccessTokenSilently } = useAuth0();

  const [readyToRender, setReadyToRender] = useState(false);
  useEffect(() => {
    async function getBlocksDBO() {
      try {
        const blocksFromDB = await fetchRequestWrapper(
          { url: "/blocks/unassigned" },
          getAccessTokenSilently,
        );
        setIncomingBlockDataInStore(blocksFromDB.blocks);
      } catch (error) {
        logClientError(
          "CreationIndex.GetBlocksDBO",
          error,
          getAccessTokenSilently,
        );
      } finally {
        // LQC-2342: success or failure, swap "Loading..." for the table.
        setReadyToRender(true);
      }
    }
    if (importData.length == 0) {
      getBlocksDBO();
    } else {
      setReadyToRender(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-full w-full">
      {readyToRender ? (
        <CreationTable
          cryptoID={cryptoID}
          theme={theme}
          getAccessTokenSilently={getAccessTokenSilently}
          importData={importData}
        />
      ) : (
        // LQC-2342: shown while the unassigned-blocks fetch is in flight, mirroring
        // the trade blotter's loading overlay. The grid itself stays unmounted so
        // saved filters aren't applied against an empty grid (see LQC-957).
        <div
          data-testid="TradeCreationLoadingContainer"
          id="TradeCreationLoadingContainer"
          className="flex h-full w-full items-center justify-center text-gray-500 dark:text-gray-400"
        >
          Loading...
        </div>
      )}
    </div>
  );
};

export default CreationIndex;
